<div class="gr-drawer">

  <div class="gr-drawer__header">
    <span class="gr-drawer__title">{{ formTitleKey() | translate }}</span>
    <button type="button" class="gr-icon-btn" (click)="cancelar()" [attr.aria-label]="'COMMON.CLOSE' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Indicador de pasos -->
  <div class="gr-steps">
    <div class="gr-step" [class.gr-step--active]="step >= 1" [class.gr-step--current]="step === 1">
      <span class="gr-step__num">1</span>
      <span>{{ 'REMESAS.FORM.PASO_CONFIGURACION' | translate }}</span>
    </div>
    <div class="gr-step" [class.gr-step--active]="step >= 2" [class.gr-step--current]="step === 2">
      <span class="gr-step__num">2</span>
      <span>{{ 'REMESAS.FORM.PASO_DESTINATARIOS' | translate }}</span>
    </div>
    <div class="gr-step" [class.gr-step--active]="step >= 3" [class.gr-step--current]="step === 3">
      <span class="gr-step__num">3</span>
      <span>{{ 'REMESAS.FORM.PASO_PREVIA' | translate }}</span>
    </div>
  </div>

  <div class="gr-drawer__body">

    <!-- ===== Paso 1: Configuración ===== -->
    <div *ngIf="step === 1" [formGroup]="form">
      <div class="gr-section-label">{{ 'REMESAS.FORM.TIPOLOGIA' | translate }}</div>
      <div class="gr-tipo-grid">
        <div class="gr-tipo-card" [class.gr-tipo-card--selected]="esComunicacion()"
             (click)="selectTipoEnvio(TIPO_COMUNICACION)">
          <mat-icon>chat_bubble_outline</mat-icon>
          <div class="gr-tipo-card__title">{{ 'REMESAS.TIPOLOGIA.COMUNICACION' | translate }}</div>
          <div class="gr-tipo-card__desc">{{ 'REMESAS.TIPOLOGIA.DESC_COMUNICACION' | translate }}</div>
        </div>
        <div class="gr-tipo-card" [class.gr-tipo-card--selected]="esNotificacion()"
             (click)="selectTipoEnvio(TIPO_NOTIFICACION)">
          <mat-icon>gavel</mat-icon>
          <div class="gr-tipo-card__title">{{ 'REMESAS.TIPOLOGIA.NOTIFICACION' | translate }}</div>
          <div class="gr-tipo-card__desc">{{ 'REMESAS.TIPOLOGIA.DESC_NOTIFICACION' | translate }}</div>
        </div>
      </div>

      <div class="gr-field">
        <label>
          {{ 'REMESAS.FORM.PROCEDIMIENTO' | translate }}
          <span *ngIf="procedimientoRequerido()" class="gr-required">*</span>
        </label>
        <select class="gr-input" formControlName="procedimiento">
          <option [ngValue]="null">{{ 'REMESAS.FORM.SIN_PROCEDIMIENTO' | translate }}</option>
          <option *ngFor="let p of procedimientos" [ngValue]="p.sia">
            {{ p.codigo ? '[' + p.codigo + '] ' : '' }}{{ p.nombre }}
          </option>
        </select>
        <small class="gr-hint" *ngIf="procedimientoRequerido()">
          {{ 'REMESAS.FORM.PROCEDIMIENTO_HINT' | translate }}
        </small>
      </div>

      <div class="gr-field">
        <label>{{ 'REMESAS.FORM.ASUNTO' | translate }}</label>
        <input type="text" class="gr-input" formControlName="concepto" maxlength="200"
               [placeholder]="(esComunicacion() ? 'REMESAS.FORM.ASUNTO_COMUNICACION' : 'REMESAS.FORM.ASUNTO_NOTIFICACION') | translate" />
      </div>

      <div class="gr-field">
        <label>
          {{ 'REMESAS.FORM.CUERPO' | translate }}
          <span class="gr-counter">{{ cuerpoLength() }} / 4000</span>
        </label>
        <textarea class="gr-input gr-textarea" formControlName="descripcion" maxlength="4000" rows="6"
                  [placeholder]="(esComunicacion() ? 'REMESAS.FORM.CUERPO_COMUNICACION' : 'REMESAS.FORM.CUERPO_NOTIFICACION') | translate"></textarea>
      </div>

      <!-- Documento de la notificación -->
      <div class="gr-field">
        <label>{{ 'REMESAS.FORM.DOCUMENTO' | translate }}</label>
        <div class="gr-doc-modes">
          <label class="gr-doc-mode"
                 [class.gr-doc-mode--active]="documentoMode === 'generar'"
                 [class.gr-doc-mode--disabled]="!plantillaModoDisponible"
                 [matTooltip]="!plantillaModoDisponible ? ('REMESAS.FIRMA_AUTOMATICA_MENSAJE' | translate) : ''"
                 matTooltipPosition="above"
                 matTooltipClass="em-tooltip">
            <input type="radio" name="documentoMode"
                   [checked]="documentoMode === 'generar'"
                   [disabled]="!plantillaModoDisponible"
                   (change)="setDocumentoMode('generar')" />
            <span class="gr-doc-mode__title">{{ 'REMESAS.FORM.DOC_GENERAR' | translate }}</span>
            <span class="gr-doc-mode__hint">{{ 'REMESAS.DOC_MODE_GENERAR_HINT' | translate }}</span>
            <span *ngIf="!plantillaModoDisponible && !firmaAutomaticaLoading" class="gr-doc-mode__warn">
              {{ 'REMESAS.FIRMA_AUTOMATICA_NO_CONFIGURADA' | translate }}
            </span>
          </label>
          <label class="gr-doc-mode" [class.gr-doc-mode--active]="documentoMode === 'adjuntar'">
            <input type="radio" name="documentoMode" [checked]="documentoMode === 'adjuntar'"
                   (change)="setDocumentoMode('adjuntar')" />
            <span class="gr-doc-mode__title">{{ 'REMESAS.FORM.DOC_ADJUNTAR' | translate }}</span>
            <span class="gr-doc-mode__hint">{{ 'REMESAS.FORM.DOC_ADJUNTAR_HINT' | translate }}</span>
          </label>
          <label class="gr-doc-mode" [class.gr-doc-mode--active]="documentoMode === 'ninguno'">
            <input type="radio" name="documentoMode" [checked]="documentoMode === 'ninguno'"
                   (change)="setDocumentoMode('ninguno')" />
            <span class="gr-doc-mode__title">{{ 'REMESAS.FORM.DOC_NINGUNO' | translate }}</span>
            <span class="gr-doc-mode__hint">{{ 'REMESAS.FORM.DOC_NINGUNO_HINT' | translate:{ tipo: ((esComunicacion() ? 'REMESAS.FORM.LA_COMUNICACION' : 'REMESAS.FORM.LA_NOTIFICACION') | translate) } }}</span>
          </label>
        </div>

        <div *ngIf="documentoMode === 'generar'" class="gr-field gr-doc-plantilla">
          <label>{{ 'REMESAS.FORM.PLANTILLA' | translate }}</label>
          <select class="gr-input" [(ngModel)]="plantillaId" [ngModelOptions]="{standalone: true}">
            <option [ngValue]="null">{{ 'REMESAS.FORM.PLANTILLA_DEFECTO' | translate }}</option>
            <option *ngFor="let p of plantillas" [ngValue]="p.id">{{ p.nombre }}</option>
          </select>
        </div>

        <div *ngIf="documentoMode === 'adjuntar'" class="gr-doc-upload">
          <input id="documento-input" type="file" accept=".pdf,.doc,.docx" hidden
                 (change)="onDocumentoFile($event)" />
          <button type="button" class="gr-btn gr-btn--ghost" (click)="triggerDocumentoInput()">
            {{ (documentoAdjuntoLabel ? 'REMESAS.FORM.CAMBIAR_DOCUMENTO' : 'REMESAS.FORM.SELECCIONAR_DOCUMENTO') | translate }}
          </button>
          <span *ngIf="documentoAdjuntoLabel" class="gr-doc-file">
            {{ documentoAdjuntoLabel }}
            <button type="button" class="gr-doc-file__remove" (click)="quitarDocumento()" [attr.aria-label]="'REMESAS.FORM.QUITAR' | translate">×</button>
          </span>
          <span *ngIf="documentoError" class="gr-doc-error">{{ documentoError }}</span>
        </div>
      </div>

      <div class="gr-field">
        <label for="modo-envio">{{ 'REMESAS.FORM.MODO_ENVIO' | translate }}</label>
        <select id="modo-envio" class="gr-input" [(ngModel)]="modoEnvio"
                [ngModelOptions]="{standalone: true}"
                [disabled]="!algunMetodoEnvioActivo"
                (ngModelChange)="onModoEnvioChange()">
          <option value="NOTIFICA" *ngIf="permiteNotifica">{{ 'REMESAS.FORM.MODO_NOTIFICA' | translate }}</option>
          <option value="APP" *ngIf="permiteEnvioSoloApp">{{ 'REMESAS.FORM.MODO_APP' | translate }}</option>
          <option value="NOTIFICA_POSTAL" *ngIf="permitePostal">{{ 'REMESAS.FORM.MODO_NOTIFICA_POSTAL' | translate }}</option>
        </select>
        <small class="gr-doc-error" *ngIf="!algunMetodoEnvioActivo">{{ 'REMESAS.FORM.SIN_METODO_ENVIO' | translate }}</small>
        <small class="gr-hint" *ngIf="algunMetodoEnvioActivo && esModoSoloApp">{{ 'REMESAS.FORM.HINT_MODO_APP' | translate }}</small>
        <small class="gr-hint" *ngIf="algunMetodoEnvioActivo && esModoPostal">{{ 'REMESAS.FORM.HINT_POSTAL' | translate }}</small>
        <small class="gr-hint" *ngIf="algunMetodoEnvioActivo && !esModoSoloApp && !esModoPostal">{{ 'REMESAS.FORM.HINT_MODO_NOTIFICA' | translate }}</small>
      </div>

      <div class="gr-toggle-row">
        <label class="fb-toggle">
          <input type="checkbox" [(ngModel)]="programar" [ngModelOptions]="{standalone: true}" />
          <span class="fb-toggle__track"><span class="fb-toggle__thumb"></span></span>
          <span class="fb-toggle__text">{{ 'REMESAS.FORM.PROGRAMAR_ENVIO' | translate }}</span>
        </label>
        <label class="fb-toggle" *ngIf="esNotificacion()" [class.fb-toggle--disabled]="!puedeFirmarAntesEnviar">
          <input type="checkbox" [(ngModel)]="firmarAntesEnviar"
                 [ngModelOptions]="{standalone: true}"
                 [disabled]="!puedeFirmarAntesEnviar" />
          <span class="fb-toggle__track"><span class="fb-toggle__thumb"></span></span>
          <span class="fb-toggle__text">{{ 'REMESAS.FORM.FIRMAR_ANTES' | translate }}</span>
        </label>
      </div>
      <small class="gr-hint" *ngIf="esNotificacion() && documentoMode === 'ninguno'">
        {{ 'REMESAS.FORM.HINT_SIN_DOC_FIRMA' | translate }}
      </small>
      <small class="gr-hint" *ngIf="esNotificacion() && documentoMode === 'adjuntar' && documentoAdjuntoLabel && !adjuntoEsPdf">
        {{ 'REMESAS.FORM.HINT_SOLO_PDF' | translate }}
      </small>
      <small class="gr-hint" *ngIf="firmarAntesEnviar && puedeFirmarAntesEnviar">
        {{ 'REMESAS.FORM.HINT_FIRMAR_ANTES' | translate }}
      </small>

      <div class="gr-field" *ngIf="firmarAntesEnviar && puedeFirmarAntesEnviar">
        <label>{{ 'REMESAS.FORM.ADMIN_FIRMA' | translate }}</label>
        <select class="gr-input" [(ngModel)]="firmanteId" [ngModelOptions]="{standalone: true}">
          <option [ngValue]="null">{{ 'REMESAS.FORM.SELECCIONA_ADMIN' | translate }}</option>
          <option *ngFor="let a of firmantes" [ngValue]="a.id">
            {{ a.nombre }} {{ a.apellido1 }} {{ a.apellido2 }} ({{ a.email }})
          </option>
        </select>
      </div>

      <div *ngIf="programar" class="gr-field">
        <label>{{ 'REMESAS.FORM.FECHA_ENVIO' | translate }}</label>
        <input type="date" class="gr-input" [(ngModel)]="fechaProgramada"
               [ngModelOptions]="{standalone: true}" [min]="todayIso" />
      </div>
    </div>

    <!-- ===== Paso 2: Destinatarios ===== -->
    <div *ngIf="step === 2">
      <div class="gr-search-row">
        <input type="text" class="gr-input" [placeholder]="'REMESAS.DEST.BUSCAR' | translate"
               [ngModel]="searchUserQuery" (ngModelChange)="onSearchChange($event)" />
        <button type="button" class="gr-btn gr-btn--ghost-sm" (click)="selectAllVisible()">
          <mat-icon>done_all</mat-icon> {{ 'REMESAS.DEST.SELECCIONAR_TODOS' | translate }}
        </button>
        <button type="button" class="gr-btn gr-btn--ghost-sm" (click)="unselectAll()" *ngIf="destinatariosCount() > 0">
          {{ 'REMESAS.DEST.LIMPIAR' | translate }}
        </button>
        <button type="button" class="gr-btn gr-btn--ghost-sm" (click)="triggerExcelInput()" [disabled]="importandoExcel">
          <mat-icon>upload_file</mat-icon> {{ 'REMESAS.DEST.IMPORTAR_EXCEL' | translate }}
        </button>
        <button type="button" class="gr-btn gr-btn--ghost-sm" (click)="descargarPlantillaExcel()"
                [title]="plantillaExcelHint()">
          <mat-icon>download</mat-icon> {{ 'REMESAS.DEST.PLANTILLA_EXCEL' | translate }}
        </button>
        <input id="excel-import-input" type="file" accept=".xlsx,.xls,.csv"
               style="display:none" (change)="onExcelFile($event)" />
      </div>
      <p class="gr-excel-hint" *ngIf="esModoSoloApp">
        {{ 'REMESAS.DEST.HINT_MODO_APP' | translate }}
      </p>
      <p class="gr-excel-hint" *ngIf="permiteDestinatariosExternos && !esModoPostal && !esModoSoloApp">
        {{ 'REMESAS.DEST.HINT_EXTERNOS' | translate }}
      </p>
      <p class="gr-excel-hint" *ngIf="!permiteDestinatariosExternos && !esModoPostal && !esModoSoloApp">
        {{ 'REMESAS.DEST.HINT_SOLO_APP' | translate }}
      </p>
      <p class="gr-excel-hint" *ngIf="esModoPostal && permiteDestinatariosExternos">
        {{ 'REMESAS.DEST.HINT_POSTAL_EXTERNOS' | translate }}
      </p>
      <p class="gr-excel-hint" *ngIf="esModoPostal && !permiteDestinatariosExternos">
        {{ 'REMESAS.DEST.HINT_POSTAL_SOLO_APP' | translate }}
      </p>

      <!-- Resultado del import Excel -->
      <div *ngIf="excelMensaje" class="gr-excel-result">
        <mat-icon>{{ excelNoEncontrados.length > 0 || excelIncompletos.length > 0 ? 'warning' : 'check_circle' }}</mat-icon>
        <span>{{ excelMensaje }}</span>
        <span *ngIf="excelNoEncontrados.length > 0" class="gr-excel-notfound">
          {{ 'REMESAS.DEST.NO_ENCONTRADOS' | translate:{ list: excelNoEncontrados.join(', ') } }}
        </span>
        <span *ngIf="excelIncompletos.length > 0" class="gr-excel-notfound">
          {{ 'REMESAS.DEST.INCOMPLETOS' | translate:{ list: excelIncompletos.join(', ') } }}
        </span>
      </div>

      <div *ngIf="importandoExcel" class="gr-empty">{{ 'REMESAS.DEST.PROCESANDO' | translate }}</div>

      <div class="gr-dest-panel gr-dest-panel--catalog">
        <div class="gr-dest-panel__head">
          <div class="gr-section-label">{{ 'REMESAS.DEST.CATALOGO' | translate }}</div>
          <p class="gr-dest-panel__hint">{{ 'REMESAS.DEST.CATALOGO_HINT' | translate }}</p>
        </div>
        <div class="gr-user-list">
          <div *ngIf="searchLoading" class="gr-empty">{{ 'REMESAS.DEST.BUSCANDO' | translate }}</div>
          <ng-container *ngIf="!searchLoading">
            <div *ngFor="let u of filteredUsers()"
                 class="gr-user-row"
                 [class.gr-user-row--selected]="isUserSelected(u)"
                 (click)="toggleUser(u)">
              <span class="gr-user-action">
                <input type="checkbox" [checked]="isUserSelected(u)" class="gr-checkbox"
                       (click)="$event.stopPropagation()" (change)="toggleUser(u)" />
              </span>
              <span class="gr-avatar">{{ iniciales(u) }}</span>
              <div class="gr-user-info">
                <div class="gr-user-name">{{ u.nombre }} {{ u.apellido1 }} {{ u.apellido2 }}</div>
                <div class="gr-user-meta">{{ u.email }} · {{ u.numero_documento }}</div>
              </div>
            </div>
            <div *ngIf="filteredUsers().length === 0" class="gr-empty">
              {{ 'REMESAS.DEST.SIN_COINCIDENCIAS' | translate }}
            </div>
          </ng-container>
        </div>
      </div>

      <div class="gr-dest-panel gr-dest-panel--selected" *ngIf="destinatariosCount() > 0">
        <div class="gr-dest-panel__head">
          <div class="gr-section-label">{{ 'REMESAS.DEST.SELECCIONADOS' | translate:{ count: destinatariosCount() } }}</div>
          <p class="gr-dest-panel__hint" *ngIf="esModoPostal">
            {{ 'REMESAS.DEST.SELECCIONADOS_HINT_POSTAL' | translate }}
          </p>
          <p class="gr-dest-panel__hint" *ngIf="!esModoPostal">
            {{ 'REMESAS.DEST.SELECCIONADOS_HINT' | translate }}
          </p>
        </div>
        <div class="gr-user-list gr-user-list--selected">
          <div *ngFor="let u of selectedUsers()"
               class="gr-user-row"
               [class.gr-user-row--clickable]="esModoPostal"
               [class.gr-user-row--editing]="esModoPostal && usuarioEnEdicion(u.id)"
               [class.gr-user-row--incompleto]="usuarioIncompleto(u)"
               (click)="editarUsuario(u.id)">
            <span class="gr-user-action">
              <button type="button" class="gr-icon-btn gr-user-remove"
                      [matTooltip]="'REMESAS.DEST.QUITAR' | translate"
                      (click)="removeSelected(u.id); $event.stopPropagation()">
                <mat-icon>close</mat-icon>
              </button>
            </span>
            <span class="gr-avatar">{{ iniciales(u) }}</span>
            <div class="gr-user-info">
              <div class="gr-user-name">
                {{ etiquetaDest(u) }}
                <span class="gr-user-kind">{{ 'REMESAS.DEST.INTERNO' | translate }}</span>
              </div>
              <div class="gr-user-meta">{{ u.email }} · {{ u.numero_documento }}</div>
            </div>
          </div>
          <div *ngFor="let e of selectedExternosList()"
               class="gr-user-row"
               [class.gr-user-row--clickable]="esModoPostal"
               [class.gr-user-row--editing]="esModoPostal && externoEnEdicion(e.numero_documento || '')"
               [class.gr-user-row--incompleto]="externoIncompleto(e)"
               (click)="editarExterno(e.numero_documento || '')">
            <span class="gr-user-action">
              <button type="button" class="gr-icon-btn gr-user-remove"
                      [matTooltip]="'REMESAS.DEST.QUITAR' | translate"
                      (click)="removeSelectedExterno(e.numero_documento || ''); $event.stopPropagation()">
                <mat-icon>close</mat-icon>
              </button>
            </span>
            <span class="gr-avatar">{{ iniciales(e) }}</span>
            <div class="gr-user-info">
              <div class="gr-user-name">
                {{ etiquetaDest(e) }}
                <span class="gr-user-kind gr-user-kind--externo">{{ 'REMESAS.DEST.EXTERNO' | translate }}</span>
              </div>
              <div class="gr-user-meta">{{ e.email }} · {{ e.numero_documento }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="gr-postal" *ngIf="esModoPostal && destinatariosCount() > 0">
        <div class="gr-section-label">{{ 'REMESAS.POSTAL.TITULO' | translate }}</div>
        <p class="gr-excel-hint">{{ 'REMESAS.POSTAL.HINT' | translate }}</p>

        <div class="gr-postal-dest" *ngIf="editingUsuario() as u">
          <div class="gr-postal-dest__head">{{ etiquetaDest(u) }}</div>
          <ng-container *ngTemplateOutlet="postalForm; context: { $implicit: domicilioUsuario(u.id) }"></ng-container>
        </div>
        <div class="gr-postal-dest" *ngIf="editingExterno() as e">
          <div class="gr-postal-dest__head">{{ etiquetaDest(e) }} <em *ngIf="e.email">{{ e.email }}</em></div>
          <ng-container *ngTemplateOutlet="postalForm; context: { $implicit: domicilioExterno(e) }"></ng-container>
        </div>
        <small class="gr-hint gr-warn" *ngIf="destinatariosPendientes() > 0">
          {{ (destinatariosPendientes() === 1 ? 'REMESAS.POSTAL.FALTAN_DATOS' : 'REMESAS.POSTAL.FALTAN_DATOS_PLURAL') | translate:{ count: destinatariosPendientes() } }}
        </small>
      </div>
    </div>

    <ng-template #postalForm let-d>
      <div class="gr-tipo-grid gr-postal__tipo" *ngIf="permitePostalInternacional">
        <button type="button" class="gr-tipo-card"
                [class.gr-tipo-card--selected]="d.tipoDomicilio !== 2"
                (click)="setTipoDomicilio(d, 1)">{{ 'REMESAS.POSTAL.ESPANA' | translate }}</button>
        <button type="button" class="gr-tipo-card"
                [class.gr-tipo-card--selected]="d.tipoDomicilio === 2"
                (click)="setTipoDomicilio(d, 2)">{{ 'REMESAS.POSTAL.EXTRANJERO' | translate }}</button>
      </div>
      <div class="gr-postal__grid" *ngIf="d.tipoDomicilio !== 2">
        <div class="gr-field">
          <label>{{ 'REMESAS.POSTAL.TIPO_VIA' | translate }}<span class="gr-required">*</span></label>
          <input class="gr-input" [(ngModel)]="d.tipoVia" [ngModelOptions]="{standalone: true}"
                 maxlength="5" [placeholder]="'REMESAS.POSTAL.TIPO_VIA_PH' | translate"
                 [class.gr-input--error]="faltaTexto(d.tipoVia)" />
        </div>
        <div class="gr-field">
          <label>{{ 'REMESAS.POSTAL.NOMBRE_VIA' | translate }}<span class="gr-required">*</span></label>
          <input class="gr-input" [(ngModel)]="d.nombreVia" [ngModelOptions]="{standalone: true}"
                 maxlength="50" [class.gr-input--error]="faltaTexto(d.nombreVia)" />
        </div>
        <div class="gr-field">
          <label>{{ 'REMESAS.POSTAL.NUMERO' | translate }}<span class="gr-required">*</span></label>
          <input class="gr-input" [(ngModel)]="d.numero" [ngModelOptions]="{standalone: true}"
                 maxlength="5" [class.gr-input--error]="faltaTexto(d.numero)" />
        </div>
        <div class="gr-field">
          <label>{{ 'REMESAS.POSTAL.CP' | translate }}<span class="gr-required">*</span></label>
          <input class="gr-input" [(ngModel)]="d.codigoPostal" [ngModelOptions]="{standalone: true}"
                 maxlength="5" placeholder="28001"
                 (ngModelChange)="onCodigoPostalChange(d)"
                 [class.gr-input--error]="faltaCpNacional(d)" />
        </div>
        <div class="gr-field">
          <label>{{ 'REMESAS.POSTAL.MUNICIPIO' | translate }}<span class="gr-required">*</span></label>
          <input class="gr-input" [(ngModel)]="d.municipio" [ngModelOptions]="{standalone: true}"
                 [class.gr-input--error]="faltaTexto(d.municipio)" />
        </div>
        <div class="gr-field">
          <label>{{ 'REMESAS.POSTAL.PROVINCIA' | translate }}<span class="gr-required">*</span></label>
          <input class="gr-input" [(ngModel)]="d.provincia" [ngModelOptions]="{standalone: true}"
                 maxlength="2" placeholder="28"
                 [class.gr-input--error]="faltaProvincia(d)" />
        </div>
        <div class="gr-field">
          <label>{{ 'REMESAS.POSTAL.POBLACION' | translate }}<span class="gr-required">*</span></label>
          <input class="gr-input" [(ngModel)]="d.poblacion" [ngModelOptions]="{standalone: true}"
                 maxlength="30" [class.gr-input--error]="faltaTexto(d.poblacion)" />
        </div>
      </div>
      <div class="gr-postal__grid" *ngIf="d.tipoDomicilio === 2">
        <div class="gr-field">
          <label>{{ 'REMESAS.POSTAL.PAIS_ISO' | translate }}<span class="gr-required">*</span></label>
          <input class="gr-input" [(ngModel)]="d.pais" [ngModelOptions]="{standalone: true}"
                 maxlength="2" placeholder="FR"
                 [class.gr-input--error]="faltaPaisIso(d)" />
        </div>
        <div class="gr-field">
          <label>{{ 'REMESAS.POSTAL.LINEA1' | translate }}<span class="gr-required">*</span></label>
          <input class="gr-input" [(ngModel)]="d.linea1" [ngModelOptions]="{standalone: true}"
                 maxlength="50" [class.gr-input--error]="faltaTexto(d.linea1)" />
        </div>
        <div class="gr-field">
          <label>{{ 'REMESAS.POSTAL.LINEA2' | translate }}</label>
          <input class="gr-input" [(ngModel)]="d.linea2" [ngModelOptions]="{standalone: true}" maxlength="50" />
        </div>
        <div class="gr-field">
          <label>{{ 'REMESAS.POSTAL.CP' | translate }}<span class="gr-required">*</span></label>
          <input class="gr-input" [(ngModel)]="d.codigoPostal" [ngModelOptions]="{standalone: true}"
                 maxlength="10" [class.gr-input--error]="faltaTexto(d.codigoPostal)" />
        </div>
      </div>
    </ng-template>

    <!-- ===== Paso 3: Vista previa ===== -->
    <div *ngIf="step === 3">
      <div class="gr-section-label">{{ 'REMESAS.PREVIEW.TITULO' | translate }}</div>

      <div class="gr-preview-card">
        <span class="gr-badge"
              [class.gr-badge--comunicacion]="esComunicacion()"
              [class.gr-badge--notificacion]="esNotificacion()">
          {{ (esComunicacion() ? 'REMESAS.TIPOLOGIA.COMUNICACION' : 'REMESAS.TIPOLOGIA.NOTIFICACION') | translate }}
        </span>
        <h3 class="gr-preview-card__title">{{ form.get('concepto')?.value }}</h3>
        <p class="gr-preview-card__body">{{ form.get('descripcion')?.value || ('REMESAS.PREVIEW.SIN_CUERPO' | translate) }}</p>
        <p class="gr-preview-card__meta">{{ 'REMESAS.PREVIEW.MODO_ENVIO' | translate }}: {{ modoEnvioLabelKey() | translate }}</p>
        <p class="gr-preview-card__meta" *ngIf="esModoPostal">
          {{ 'REMESAS.PREVIEW.CORREO_POSTAL' | translate }}
          <strong>{{ (destinatariosCount() === 1 ? 'REMESAS.PREVIEW.DOMICILIO' : 'REMESAS.PREVIEW.DOMICILIOS') | translate:{ count: destinatariosCount() } }}</strong>
        </p>
        <p class="gr-preview-card__meta">
          {{ 'REMESAS.PREVIEW.DOCUMENTO' | translate }}
          <strong *ngIf="documentoMode === 'adjuntar' && documentoAdjuntoLabel">{{ documentoAdjuntoLabel }} {{ 'REMESAS.PREVIEW.ADJUNTO_COMUN' | translate }}</strong>
          <strong *ngIf="documentoMode === 'ninguno'">{{ 'REMESAS.PREVIEW.SIN_DOCUMENTO' | translate }}</strong>
          <strong *ngIf="documentoMode === 'generar'">{{ 'REMESAS.DOC_MODE_RESUMEN_GENERADO' | translate }} · {{ plantillaNombreSel }}</strong>
        </p>
      </div>

      <div class="gr-section-label">{{ 'REMESAS.PREVIEW.DESTINATARIOS' | translate:{ count: destinatariosCount() } }}</div>
      <div class="gr-tags">
        <span *ngFor="let u of selectedUsers()" class="gr-tag gr-tag--readonly">
          {{ etiquetaDest(u) }}
          <em *ngIf="esModoPostal">{{ domicilioResumen(domicilioUsuario(u.id)) }}</em>
        </span>
        <ng-container *ngIf="!esModoSoloApp">
          <span *ngFor="let e of selectedExternosList()" class="gr-tag gr-tag--readonly gr-tag--externo">
            {{ etiquetaDest(e) }} <em *ngIf="e.email">{{ e.email }}</em>
            <em *ngIf="esModoPostal">{{ domicilioResumen(e.domicilio) }}</em>
          </span>
        </ng-container>
      </div>

      <div class="gr-ready-banner" *ngIf="canFinish()">
        <mat-icon>check_circle</mat-icon>
        <span *ngIf="!programar">{{ 'REMESAS.PREVIEW.LISTO_ENVIAR' | translate }}</span>
        <span *ngIf="programar && fechaProgramada">{{ 'REMESAS.PREVIEW.LISTO_PROGRAMAR' | translate:{ fecha: fechaProgramada } }}</span>
        <span *ngIf="programar && !fechaProgramada" class="gr-warn">{{ 'REMESAS.PREVIEW.FALTA_FECHA' | translate }}</span>
        <span *ngIf="firmarAntesEnviar && puedeFirmarAntesEnviar">{{ 'REMESAS.PREVIEW.SE_FIRMARA' | translate }}</span>
        <span *ngIf="firmarAntesEnviar && puedeFirmarAntesEnviar && !firmanteId" class="gr-warn">
          {{ 'REMESAS.PREVIEW.FALTA_FIRMANTE' | translate }}
        </span>
      </div>
    </div>
  </div>

  <!-- ===== Footer ===== -->
  <div class="gr-drawer__footer">
    <div class="gr-footer__left">
      <button type="button" class="gr-btn gr-btn--ghost" (click)="prev()" *ngIf="step > 1">
        <mat-icon>arrow_back</mat-icon> {{ 'REMESAS.FORM.ANTERIOR' | translate }}
      </button>
      <button type="button" class="gr-btn gr-btn--ghost" (click)="next()" *ngIf="step < 3"
              [disabled]="(step === 1 && !step1Valid()) || (step === 2 && (destinatariosCount() === 0 || !destinatariosCompletos()))">
        {{ 'REMESAS.FORM.SIGUIENTE' | translate }} <mat-icon>arrow_forward</mat-icon>
      </button>
    </div>
    <div class="gr-footer__right">
      <button type="button" class="gr-btn gr-btn--ghost" (click)="guardarBorrador()"
              [disabled]="!step1Valid() || (destinatariosCount() > 0 && !destinatariosCompletos())">
        <mat-icon>save</mat-icon> {{ 'REMESAS.FORM.GUARDAR_BORRADOR' | translate }}
      </button>
      <button type="button" class="gr-btn gr-btn--ghost"
              *ngIf="firmarAntesEnviar && puedeFirmarAntesEnviar"
              [disabled]="!canFinish() || !firmanteId" (click)="solicitarFirma()">
        <mat-icon>how_to_reg</mat-icon> {{ 'REMESAS.FORM.SOLICITAR_FIRMA' | translate }}
      </button>
      <button type="button" class="gr-btn gr-btn--primary" *ngIf="!programar"
              [disabled]="!canFinish()" (click)="enviarAhora()">
        <mat-icon>{{ firmarAntesEnviar && puedeFirmarAntesEnviar ? 'draw' : 'send' }}</mat-icon>
        {{ (firmarAntesEnviar && puedeFirmarAntesEnviar ? 'REMESAS.FORM.FIRMAR_ENVIAR' : 'REMESAS.FORM.ENVIAR_AHORA') | translate }}
      </button>
      <button type="button" class="gr-btn gr-btn--primary" *ngIf="programar"
              [disabled]="!canFinish() || !fechaProgramada" (click)="programarEnvio()">
        <mat-icon>{{ firmarAntesEnviar && puedeFirmarAntesEnviar ? 'draw' : 'schedule' }}</mat-icon>
        {{ (firmarAntesEnviar && puedeFirmarAntesEnviar ? 'REMESAS.FORM.FIRMAR_PROGRAMAR' : 'REMESAS.FORM.PROGRAMAR_ENVIO') | translate }}
      </button>
    </div>
  </div>
</div>
